module.exports = __webpack_public_path__ + "static/media/mapBgM.711e26ed.svg";